jQuery(document).ready(function($) {
    $("input#keyword").on('keyup', function(e){
        var delayTime;
        clearTimeout(delayTime);
        if (jQuery('#keyword').val().length > 2) {
            delayTime = setTimeout(function() {
                $.ajax({
                    type: 'POST',
                    url: ajaxSearch.ajaxurl,
                    data: { 
                        action: 'nitg_data_fetch', 
                        keyword: $('#keyword').val()
                    },
                    beforeSend: function(data) {
                        $('#datafetch').html('<img class="loader" src="/wp-content/plugins/ajax-search-posts/assets/img/loader.png">');
                    },
                    success: function(data) {
                        $('#datafetch').html(data);
                    }  
                });
            }, 500);
        }
    });
});